var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-index"},[_c('FrontNavbar'),_c('div',{staticClass:"container-fluid px-0",staticStyle:{"overflow":"hidden"}},[_c('main',[_c('router-view')],1)]),_c('FrontFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }